import * as React from "react";
const HeadingTwoSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 5H5v4h5V5H9V4h3v1h-1v9h1v1H9v-1h1v-4H5v4h1v1H3v-1h1V5H3V4h3v1Zm8.5 6a.5.5 0 0 0-.5.5v.5h-1v-.5a1.5 1.5 0 0 1 3 0v.06c0 .415-.164.811-.457 1.104L14.207 14H16v1h-3v-1l1.836-2.043a.56.56 0 0 0 .164-.396V11.5a.5.5 0 0 0-.5-.5Z" }));
HeadingTwoSmall.displayName = "HeadingTwoSmall";
var HeadingTwoSmall_default = HeadingTwoSmall;
export {
  HeadingTwoSmall_default as default
};
